/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'sad': {
    width: 10.203,
    height: 10.202,
    viewBox: '0 0 10.203 10.202',
    data: '<path pid="0" _fill="#010101" d="M1.495 1.492a5.102 5.102 0 1 0 7.215.001l-.001-.001a5.107 5.107 0 0 0-7.214 0m6.657 6.665C6.468 9.841 3.737 9.84 2.054 8.155S.37 3.74 2.056 2.057a4.312 4.312 0 0 1 6.097 0 4.319 4.319 0 0 1-.001 6.1M7.39 7.124a.291.291 0 0 1-.531.229 1.862 1.862 0 0 0-3.359 0 .289.289 0 0 1-.377.153.287.287 0 0 1-.161-.371l.005-.011a2.44 2.44 0 0 1 4.423 0M3.195 3.86l-.252.08a.309.309 0 0 1-.381-.194.306.306 0 0 1 .198-.382l1.224-.381a.31.31 0 0 1 .382.194.307.307 0 0 1-.153.382.594.594 0 1 1-1.018.336m4.534-.134a.3.3 0 0 1-.378.195l-.003-.001-.248-.08a.596.596 0 1 1-1.018-.335.3.3 0 0 1-.152-.358.304.304 0 0 1 .381-.199l1.224.381a.298.298 0 0 1 .197.371l-.003.011"/>'
  }
})
